import validateForm from 'root/src/client/logic/form/util/validateForm'
import pushStepId from 'root/src/client/logic/form/actions/pushStepId'
import nextStepIdSelector from 'root/src/client/logic/form/selectors/nextStepIdSelector'
import isSingleStepSelector from 'root/src/client/logic/form/selectors/isSingleStepSelector'
import clearForm from 'root/src/client/logic/form/actions/clearForm'

export default ({ moduleKey, moduleId, stepId }) => async (dispatch, getState) => {
	const state = getState()
	try {
		if (isSingleStepSelector(state, { moduleId, stepId })) {
			dispatch(clearForm({ moduleKey, moduleId }))
		} else {
			await validateForm(moduleKey, state)
		}
		dispatch(pushStepId({
			moduleKey,
			stepId: stepId || nextStepIdSelector(state, { moduleKey, moduleId }),
		}))
		return getState()
	} catch (errors) {
		return state
	}
}
